import { client } from "@/config/client"

export function deleteById(id: string) {
  return client.del("/v1/learning-paths/" + id)
}
